import React, { FunctionComponent } from 'react';
import BucketComponent from './Bucket';
import { JoinBucket } from '../../../models/offer/OfferRule.model';

type QueryBuilderProps = {
  bucket: JoinBucket;
  setRootBucket: (bucket: JoinBucket) => void;
  offerData?: any;
  setIsFieldErrorEnabled: (value: boolean) => void;
};

const QueryBuilder: FunctionComponent<QueryBuilderProps> = ({
  bucket,
  setRootBucket,
  offerData = {}, 
  setIsFieldErrorEnabled

}) => {
  // todo: wip
  return (
    <BucketComponent
      bucket={bucket}
      rootBucket={bucket}
      isParent
      setRootBucket={setRootBucket}
      offerData={offerData}
      setIsFieldErrorEnabled={setIsFieldErrorEnabled}
    />
  );
};

export default QueryBuilder;
